import React from 'react';

const Hero = ({ onJoinWaitlist }) => {
  return (
    <div className="hero-section">
      <div className="container">
        {/* Main Headline */}
        <h1 className="hero-title">
          The Future of
          <br />
          <span className="hero-gradient-text">
            Venture Intelligence
          </span>
        </h1>

        {/* Subtitle */}
        <p className="hero-subtitle">
          Power data-driven decisions across all private markets — just as Bloomberg and FactSet do for public markets. 
          Access real-time startup data, automate due diligence, and quantify performance globally.
        </p>

        {/* Key Value Props */}
        <div className="value-props">
          <div className="value-prop">
            <div className="value-dot"></div>
            Real-time Startup Data
          </div>
          <div className="value-prop">
            <div className="value-dot"></div>
            Automated Due Diligence
          </div>
          <div className="value-prop">
            <div className="value-dot"></div>
            Global Performance Analytics
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="cta-buttons">
          <button onClick={onJoinWaitlist} className="btn-primary">
            Join the Waitlist
            <svg style={{marginLeft: '8px', width: '20px', height: '20px'}} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>

        {/* Stats */}
        <div className="stats-grid">
          <div className="stat-item">
            <div className="stat-number">$2.5T+</div>
            <div className="stat-label">Global VC Market Size</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">15,000+</div>
            <div className="stat-label">Active VC Firms</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">500K+</div>
            <div className="stat-label">Startups Tracked</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
